// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"606":"0f003d8a","703":"cea3080a"}[chunkId] + ".chunk.js";
};